<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
            <!-- //文本搜索内容 -->
            <div class="fun-panel fun-search-form-wrapper">
                <a-form :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                    <a-row :gutter="[0, 6]">
                        <a-col :span="6">
                            <a-form-item label="专家姓名">
                                <a-input v-model="queryParams.zjxm" placeholder="" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="是否可打印">
                                <FGDictSelectCN dictNo="1101" v-model="queryParams.dybj" placeholder="" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <span class="fun-search-form-buttons" :style="{ float: 'right', overflow: 'hidden' }">
                                <a-button type="primary" @click="loadData" style="margin-right: 8px">查询</a-button>
                                <a-button @click="reset">重置</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
        </a-anchor>

        <div class="fun-panel">
            <a-spin :spinning="tableDataLoading">
                <!-- 工具栏 -->
                <vxe-toolbar
                    size="mini"
                    custom
                    :refresh="{
                        query: () => {
                            this.loadData();
                        }
                    }"
                >
                </vxe-toolbar>
                <!-- 表格 -->
                <vxe-table
                    ref="table"
                    size="mini"
                    resizable
                    auto-resize
                    row-id="id"
                    align="left"
                    :max-height="$FG_util.getTableHeightDirect(0)"
                    header-align="center"
                    highlight-hover-row
                    highlight-current-row
                    show-overflow="tooltip"
                    :data="tableData"
                    :sort-config="{
                        trigger: 'cell',
                        defaultSort: { field: sort.field, order: sort.order },
                        remote: true,
                        orders: ['asc', 'desc']
                    }"
                    @sort-change="handleSortChange"
                    @cell-dblclick="doubleClick"
                >
                    <vxe-table-column type="seq" title="序号" width="80" sortable align="center"> </vxe-table-column>
                    <vxe-table-column field="zjxm" title="专家姓名" width="120" sortable align="center"></vxe-table-column>
                    <vxe-table-column field="dwmc" title="单位名称" min-width="300"></vxe-table-column>
                    <vxe-table-column field="zymc" title="专业一" width="200" align="center"></vxe-table-column>
                    <vxe-table-column field="xb" title="性别" width="100" align="center"></vxe-table-column>
                    <vxe-table-column field="zc" title="职称" width="120" align="center"></vxe-table-column>
                    <vxe-table-column field="zjhm" title="身份证号" width="180" align="center"></vxe-table-column>
                    <vxe-table-column field="sjhm" title="手机号" width="120" align="center"></vxe-table-column>
                    <vxe-table-column title="操作" width="160" align="center">
                        <template v-slot="scope">
                            <span class="btn_edit" @click="print(scope.row)">打印</span>
                        </template>
                    </vxe-table-column>
                </vxe-table>
                <vxe-pager
                    background
                    size="mini"
                    style="margin-top:5px"
                    :current-page.sync="pageinfo.pageNo"
                    :page-size.sync="pageinfo.pageSize"
                    :total="pageinfo.total"
                    :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
                    @page-change="handlePageChange"
                >
                </vxe-pager>
            </a-spin>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters, mapActions } = createNamespacedHelpers("user");
export default {
    name: "Zjzsdy",
    components: {},
    data() {
        return {
            tableData: [], //表格数据
            tableDataLoading: false,
            // 分页
            pageinfo: {
                pageNo: 1,
                pageSize: 20,
                total: 0
            },
            // 排序
            sort: {
                field: "zjxm",
                order: "asc"
            },
            // 查询条件
            queryParams: {}
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken", "getNoticeId"])
    },
    mounted() {
        this.loadData();
    },
    methods: {
        ...mapActions(["setNoticeId"]),
        //双击事件
        doubleClick({ row }) {
            this.edit(row);
        },
        //点击表头排序
        handleSortChange({ property, order }) {
            this.sort.field = property;
            this.sort.order = order;
            this.loadData();
        },
        //分页点击
        handlePageChange({ currentPage, pageSize }) {
            this.pageinfo.pageNo = currentPage;
            this.pageinfo.pageSize = pageSize;
            this.loadData();
        },
        //查询列表数据
        loadData(id) {
            // 如果没有指定选中记录则选中刷新前选中的记录
            if (!id) {
                let row = this.$refs.table.getCurrentRecord();
                if (row) {
                    id = row.id;
                }
            }
            this.tableDataLoading = true;
            this.queryParams.dwmc = this.getUserInfo.companyInfo.dwmc;

            this.$FG_http
                .post(
                    "./api/main/zsdy/zjzsdy/list",
                    {
                        pageNo: this.pageinfo.pageNo,
                        pageSize: this.pageinfo.pageSize,
                        queryParams: this.queryParams,
                        sort: this.sort
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.tableDataLoading = false;

                    if (success) {
                        this.tableData = data.data;
                        // 需要设置当前页，因为查询可能导致当前页发生变化
                        this.pageinfo.pageNo = data.pageinfo.pagenum;
                        this.pageinfo.total = data.pageinfo.maxrow;
                    } else {
                        // 数据加载失败清空表格
                        this.tableData = [];
                    }
                })
                .then(() => {
                    this.$nextTick(() => {
                        let row = null;
                        // 获取之前选择的记录
                        if (id) {
                            row = this.$refs.table.getRowById(id);
                        }
                        // 如果之前没有选择记录且表格不为空则选择第一条记录
                        if (!row && this.tableData.length > 0) {
                            row = this.$refs.table.getRowById(this.tableData[0].id);
                        }
                        if (row) {
                            // 设置当前记录
                            this.$refs.table.setCurrentRow(row);
                        } else {
                            // 清空当前行
                            this.$refs.table.clearCurrentRow();
                        }
                    });
                });
        },
        // 打印
        print(row) {
            // 非会员单位的专家不可以打印;
            if (row.dwlx !== "会员单位") {
                this.$FG_message.error("操作失败！专家所在单位不是会员单位，不可打印证书，请检查！");
                return;
            }
            this.tableDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zsdy/zjzsdy/reportZJZS",
                    {
                        dataId: row.id
                    },
                    {
                        responseType: "blob",
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.tableDataLoading = false;
                    if (success) {
                        let binaryData = [];
                        binaryData.push(data);
                        let url = window.URL.createObjectURL(new Blob(binaryData, { type: "application/pdf" }));
                        window.open(url);
                    } else {
                        this.$FG_message.error("P0002");
                    }
                });
        },
        //重置文本内容
        reset() {
            this.queryParams = {};
        }
    }
};
</script>
